import axios from 'axios';

// Запрос редактора опросов: JSON с CSRF-токеном страницы, единый для вопросов, вариантов и уточнений
export default function request(method, url, data) {
	return axios({
		response_type: "json",
		headers: {
			"X-Requested-With": "XMLHttpRequest",
			"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
		},
		method,
		url,
		data
	});
}
